import {
    createBrowserRouter
} from "react-router-dom";
import './App.scss';
import AppWrapper from "./pages/AppWrapper";
import ErrorPage from "./pages/ErrorPage";
import { AUTH_CONFIRM_BASE_ROUTH, AUTH_CONFIRM_ROUTES, LINEAR_AUTH_CONFIRM_ROUTES } from "./routes/AuthConfirmRouter";
import { ROUTES } from "./routes/CaiExperienceRouter";
import { LINEAR_BASE_ROUTE } from "./routes/linearRouteConstants";
import { LINEAR_ROUTES } from "./routes/LinearCaiExperienceRouter";

export const router = createBrowserRouter([
     {
        path: `/${LINEAR_BASE_ROUTE}/${AUTH_CONFIRM_BASE_ROUTH}/:token`,
        element: <AppWrapper />,
        children: LINEAR_AUTH_CONFIRM_ROUTES       // linear
    },
    {
        path: `/${LINEAR_BASE_ROUTE}/:token`,
        element: <AppWrapper />,
        children: LINEAR_ROUTES     // linear
    },
    {
        path: `/${AUTH_CONFIRM_BASE_ROUTH}/:token`,
        element: <AppWrapper />,
        children: AUTH_CONFIRM_ROUTES            // unipol
    },
    {
        path: ":token",
        element: <AppWrapper />,
        children: ROUTES            // unipol
    },
    {
        path: ":token/:route",
        element: <AppWrapper />,
        children: ROUTES            // unipol
    },
    {
        path: "*",
        element: <ErrorPage />
    }
]);
